import { Snackbar, Alert, AlertTitle } from "@mui/material";
import { useState } from "react";

const MessageBase = (props) => {
  const {
    content,
    duration,
    type,
    onClose,
    isShowTitle = false,
    title = "",
  } = props;
  const [open, setOpen] = useState(true);

  const handleCloseMessage = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <Snackbar
      sx={{ height: "100vh" }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={open}
      autoHideDuration={duration}
    >
      <Alert onClose={handleCloseMessage} severity={type}>
        {isShowTitle && <AlertTitle>{title}</AlertTitle>}
        <span>{content}</span>
      </Alert>
    </Snackbar>
  );
};

export default MessageBase;
